import React, {Component} from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import PropTypes from 'prop-types';
import {customStandardActions} from "../../../Utils/Grid/StandardActions";
import ToolbarFiltroUsuarios from './filtroUsuarios';
import { Link, Redirect } from 'react-router-dom';
import ToolbarSimple from '../../../Utils/Toolbar/ToolbarSimple';
import {estado_bodega} from '../../../../../utility/icons';
import { SeriesRecibos, CajaIcono } from '../../../../../utility/icons';


export default class UsuariosGrid extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: false
    };

    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }
    boton_adicional = (id, row) => {
        const tipo = "U"
        return (
            <Link to={`bodega_usuario/${id}/${tipo}`} className="px-2" >
                <img
                    className="action-img"
                    title="adicional"
                    src={estado_bodega}
                    alt="Estado bodega" />
            </Link>

        )
    }
    boton_adicional2 = (id, row) => {
        return (
            <div style={{ width: '2.1rem' }}></div>
        )
    }

    botonAsignarSerie = (id, row) => {
        return (
            <Link to={`usuario-series/${id}/editar`} className="px-2" >
                <img
                    className="action-img"
                    title="Serie de Recibos de Caja"
                    src={SeriesRecibos}
                    alt="Recibos de Caja"/>
            </Link>
        )
    }

    asignarPermisosCajasButton = (id, row) => {
        return (
            <Link to={`usuario-cajas/${id}`} className="px-2" >
                <img
                    className="Cuentas-img"
                    title="Permisos para Cajas Chicas"
                    src={CajaIcono}
                    alt="Permisos para Cajas Chicas"/>
            </Link>
        )
    }

    render(){
        const { data, loader, listar: onPageChange, onSortChange, eliminar, page, permisos } = this.props;
        if(permisos["usuarios"] === false) {
            if(!!permisos[`ver_usuarios`] === false) {
                return <Redirect to={`/`} />
            }
        } 
        return(
            <div className="Container bg-white">
                <h3 className="t-primary m-t p-t">USUARIOS</h3>
                <div className="row justify-content-end">
                    <div className="col-md-10 col-sm-10 col-12">
                        <ToolbarSimple
                            textBoton={permisos.crear_usuarios ? "AGREGAR" : ""}
                            ruta="/usuario/nuevo"
                            buscar={this.props.searchChange}
                            buscador={this.props.search}
                            placeholder={"Buscar por: Nombre, Apellido "}
                            permisos={permisos.usuarios}
                            estatefilterBar={true}
                            filterbar={
                                <ToolbarFiltroUsuarios
                                changeEstado={this.props.changeEstado}
                                valorEstado={this.props.estado}
                                />
                            }
                        />
                        {/* <Link className="btn btn-primary" to="/usuario/nuevo">AGREGAR</Link> */}
                    </div>
                </div>
                <div className="row">
                    <div className="mb-4 col-12">
                        <div className="mb-4 ">
                            <div className=" card-header"><h6 className="m-0"></h6></div>
                            <div className="p-0 px-3 pt-3">
                                <Grid hover page={page} striped data={data} loading={loader} onPageChange={onPageChange} onSortChange={onSortChange} >
                                    {
                                        this.props.permisos.usuarios && this.props.estado.value &&
                                        (<TableHeaderColumn
                                            dataField="id"
                                            dataAlign=""
                                            dataSort
                                            dataFormat={(cell, row) => {
                                                return customStandardActions(cell, {
                                                    eliminar: permisos.eliminar_usuarios ? eliminar: undefined,
                                                    editar: permisos.editar_usuarios ? "usuario": undefined,
                                                    adicional5: row.permisos.recibo_caja_chica ? this.botonAsignarSerie : undefined,
                                                    adicional4: row.permisos.bodegas | row.permisos.ver_bodegas ? this.boton_adicional: this.boton_adicional2,
                                                    adicional7: row.permisos.cajaschicas ? this.asignarPermisosCajasButton : undefined,
                                                });
                                            }}
                                        >
                                        </TableHeaderColumn>)
                                    }
                                    <TableHeaderColumn
                                        isKey
                                        dataField="first_name"
                                        dataSort
                                    >
                                        NOMBRE
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="last_name"
                                        dataSort
                                    >
                                        APELLIDOS
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="profile"
                                        dataFormat={cell => cell ? cell.phone : "---"}
                                        dataSort
                                    >
                                        CONTACTO
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="email"
                                        dataSort
                                    >
                                        CORREO
                                    </TableHeaderColumn>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

